import getLatexEquation  from "./functions/getLatexEquation/GetLatexEquation";
import { WordStateParserFunction } from "./functions/wordStateParser/WordStateParser";

type ParsedExpression = {
  eq: string;
  text: string;
};

export function parseExpression(input?: string): ParsedExpression {

  const safeInput = input ?? '';

  return {
    eq: getLatexEquation(safeInput),
    text: WordStateParserFunction(safeInput)
  };
}